<script setup>
import BulletPoint from "@/components/common/base/BulletPoint";

const CountryAmount = {
  minimum: 5,
  maximum: 25,
};

const props = defineProps({
  countriesList: {
    type: Array,
    default: () => [],
  },
});

function getColumnClassOnCountriesCount(countriesList) {
  const count = countriesList.length;
  if (count > CountryAmount.minimum && count <= CountryAmount.maximum) {
    return "min-[500px]:columns-2";
  }
  if (count > CountryAmount.maximum) {
    return "min-[500px]:columns-2 md:columns-3";
  }
  return "columns-1";
}

function countriesColumnClassOnCount() {
  return getColumnClassOnCountriesCount(props.countriesList);
}
</script>

<template>
  <ul
    :class="countriesColumnClassOnCount()"
    class="list-none mt-5 mb-8 gap-5 columns-1"
    automation-id="profileRecognitionModal-countryList"
  >
    <li v-for="country in props.countriesList" :key="country" class="flex items-center">
      <BulletPoint />
      <span>{{ country }}</span>
    </li>
  </ul>
</template>